import React, { useEffect, useState } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

let initialOptions = [
  { value: 'licensed', label: 'Flat Rate' },
  { value: 'metered', label: 'Usage Based' },
];
const PricingModelInput = ({ formData, onChange, planType, disabled = false }) => {
  const [options, setOptions] = useState(initialOptions);

  useEffect(() => {
    if (planType === 'prepaid') {
      setOptions([{ value: 'licensed', label: 'Flat Rate' }]);
    } else {
      setOptions(initialOptions);
    }
  }, [planType]);

  const handleChange = (e) => {
    let newValue = e.target.value;
    const update = {
      ...formData,
      pricing_model: newValue,
    };
    if (newValue === 'licensed') {
      update.billing_schema = null;
      update.documents_limit = 1;
    } else if (newValue === 'metered') {
      update.billing_schema = 'per_unit';
      update.documents_limit = 0;
    }

    onChange(update);
  };

  return (
    <FormControl fullWidth required>
      <InputLabel shrink>Pricing Model</InputLabel>
      <Select
        label="Pricing Model"
        value={formData.pricing_model}
        onChange={handleChange}
        size="small"
        disabled={disabled}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default PricingModelInput;
